(() => {
  // Cached DOM references
  const header = document.querySelector('header');
  const preNav = document.querySelector('.pre-nav');
  const mainNavEl = document.querySelector('.main-nav');
  const mobileMenuBtn = document.getElementById('mobileMenuButton');
  const mobileMenu = document.querySelector('.mobile-menu-container');
  const mobileNav = document.getElementById('mobileMenu');
  const desktopNav = document.querySelector('#main-nav');

  // Consolidated document click deactivators
  const deactivators = [];

  const initMenu = (selector) => {
    const menu = document.querySelector(selector);
    if (!menu) return;

    const parents = menu.querySelectorAll(':scope > .menu-item-has-children');
    let activeItem = null;

    const activate = (item) => {
      if (activeItem && activeItem !== item) {
        activeItem.classList.remove('_active');
        activeItem._tapped = false;
      }
      item.classList.add('_active');
      activeItem = item;
    };

    const deactivateAll = () => {
      if (activeItem) {
        activeItem.classList.remove('_active');
        activeItem._tapped = false;
        activeItem = null;
      }
    };

    parents.forEach(el => { el._tapped = false; });

    menu.addEventListener('click', (e) => {
      const li = e.target.closest(selector + ' > .menu-item-has-children');
      if (!li) return;

      const directLink = li.querySelector(':scope > a');
      const clickedLink = e.target.closest('a');

      if (clickedLink && clickedLink !== directLink) return;

      if (clickedLink === directLink) {
        e.preventDefault();
      }

      if (li._tapped) {
        li.classList.remove('_active');
        li._tapped = false;
        activeItem = null;
      } else {
        deactivateAll();
        li.classList.add('_active');
        li._tapped = true;
        activeItem = li;
      }
    });

    menu.addEventListener('mouseenter', (e) => {
      const li = e.target.closest(selector + ' > .menu-item-has-children');
      if (li && e.target === li) activate(li);
    }, true);

    menu.addEventListener('mouseleave', (e) => {
      const li = e.target.closest(selector + ' > .menu-item-has-children');
      if (li && e.target === li && !li._tapped) {
        li.classList.remove('_active');
        if (activeItem === li) activeItem = null;
      }
    }, true);

    menu.addEventListener('focusout', (e) => {
      if (e.relatedTarget && menu.contains(e.relatedTarget)) return;
      requestAnimationFrame(() => {
        if (menu.contains(document.activeElement)) return;
        if (menu.matches(':hover')) return;
        deactivateAll();
        menu.querySelectorAll('.sub-active').forEach(el => {
          el.classList.remove('sub-active');
        });
      });
    });

    deactivators.push((e) => {
      if (!e.target.closest(selector)) deactivateAll();
    });
  };

  // Single document click listener for all menu deactivators
  document.addEventListener('click', (e) => {
    for (let i = 0; i < deactivators.length; i++) {
      deactivators[i](e);
    }
  });

  initMenu('.pre-nav .menu');
  initMenu('#main-nav');

  // Mobile menu
  if (mobileMenuBtn && mobileMenu) {
    const updateMenuPosition = () => {
      if (!mainNavEl) return;
      const h = mainNavEl.getBoundingClientRect().bottom;
      mobileMenu.style.top = h + 'px';
      mobileMenu.style.height = 'calc(100vh - ' + h + 'px)';
    };

    const closeMenu = () => {
      mobileMenuBtn.classList.remove('_active');
      mobileMenu.classList.remove('_active');
      document.body.classList.remove('menu-open');
      mobileMenuBtn.setAttribute('aria-label', 'Open Menu');
    };

    // rAF-throttled scroll handler
    let scrollTicking = false;
    const onScroll = () => {
      if (!scrollTicking) {
        requestAnimationFrame(() => {
          updateMenuPosition();
          scrollTicking = false;
        });
        scrollTicking = true;
      }
    };

    updateMenuPosition();
    window.addEventListener('resize', () => {
      updateMenuPosition();
      updateStickyHeader();
      if (window.innerWidth >= 900) closeMenu();
    });
    window.addEventListener('scroll', onScroll, { passive: true });

    mobileMenuBtn.addEventListener('click', () => {
      mobileMenuBtn.classList.toggle('_active');
      mobileMenu.classList.toggle('_active');
      document.body.classList.toggle('menu-open');
      mobileMenuBtn.setAttribute('aria-label', mobileMenu.classList.contains('_active') ? 'Close Menu' : 'Open Menu');
      if (!mobileMenu.classList.contains('_active')) {
        mobileMenu.querySelectorAll('.mobile-submenu-panel._active').forEach(p => p.classList.remove('_active'));
      }
    });
  }

  // Mobile submenu slide-in
  if (mobileNav) {
    mobileNav.addEventListener('click', (e) => {
      const link = e.target.closest('a');
      if (!link) return;
      const li = link.closest('.menu-item-has-children');
      if (!li || link !== li.querySelector(':scope > a')) return;
      const panel = li.querySelector(':scope > .mobile-submenu-panel');
      if (!panel) return;
      e.preventDefault();
      panel.classList.add('_active');
      const first = panel.querySelector('.vertical.menu > li:first-child > a');
      if (first) first.focus();
    });

    mobileNav.addEventListener('click', (e) => {
      const btn = e.target.closest('.mobile-back-btn');
      if (!btn) return;
      const panel = btn.closest('.mobile-submenu-panel');
      panel.classList.remove('_active');
      const parentLi = panel.closest('li');
      if (parentLi) {
        const parentLink = parentLi.querySelector(':scope > a');
        if (parentLink) parentLink.focus();
      }
    });
  }

  // 4th-level flyout for #main-nav 3rd-level items with children
  if (desktopNav) {
    const subSelector = '#main-nav > li > .menu > li > .menu > li.menu-item-has-children';

    desktopNav.addEventListener('mouseenter', (e) => {
      const li = e.target.closest(subSelector);
      if (li && e.target === li) li.classList.add('sub-active');
    }, true);

    desktopNav.addEventListener('mouseleave', (e) => {
      const li = e.target.closest(subSelector);
      if (li && e.target === li) li.classList.remove('sub-active');
    }, true);

    desktopNav.addEventListener('focusin', (e) => {
      const li = e.target.closest(subSelector);
      if (!li) return;
      desktopNav.querySelectorAll('.sub-active').forEach(el => {
        if (el !== li) el.classList.remove('sub-active');
      });
      li.classList.add('sub-active');
    }, true);
  }

  // Sticky header: at mobile, offset top by pre-nav height so only .main-nav sticks
  const updateStickyHeader = () => {
    if (!header || !preNav) return;
    header.style.top = (window.innerWidth < 900) ? -preNav.offsetHeight + 'px' : '0';
  };
  updateStickyHeader();
})();
